<template>
  <div class="meu-perfil">
    <g-card :expansivel="false" :temCabecalho="false">
      <div class="cabecalho-formulario">
        <div class="titulo-formulario">Meu Perfil</div>
      </div>

      <div class="espacamento-filtros">
        <div class="titulo-grupo-formulario"> Meus dados </div>
        <div class="container-dados ">
            <div class="input-meu-perfil nome">
              <div class="titulo-conteudo-filtros">Nome</div>
              <div class="input-nome">
                <PInputText class="borda" v-model="dadosUsuario.nome" ref="inputNome" :disabled="disablednome"></PInputText>
                <i class="pi pi-pencil lapis" @click="desativarnome" />
              </div>
            </div>
  
  
          <div class="input-meu-perfil telefone">
  
            <div class="titulo-conteudo-filtros">Telefone</div>
            <div class="input-nome">
              <PInputMask class="borda" v-model="dadosUsuario.telefone" :disabled="disabledtelefone" mask="(99) 99999-9999" ></PInputMask>
              <i class="pi pi-pencil lapis" @click="desativartelefone" />
            </div>
          
          </div>
  
          <div class="input-meu-perfil login">
            <div class="titulo-conteudo-filtros">Nome de Usuário</div>
            <PInputText v-model="dadosUsuario.login" disabled></PInputText>
          </div>
  
          <div class="input-meu-perfil data-validade">
            <div class="titulo-conteudo-filtros">Ultima Troca de Senha</div>
            <PInputText v-model="dadosUsuario.dataValidadeTicket" disabled></PInputText>
          </div>
  
          <div class="input-meu-perfil email">
            <div class="titulo-conteudo-filtros">Email</div>
            <PInputText v-model="dadosUsuario.email" disabled></PInputText>
          </div>
        </div>
        

      </div>
      <div class="container-alterar-senha">
        <div class="texto-alterar-senha" @click="abrirPopupTrocarSenha"> Alterar minha senha </div>
      </div>
      <div class="alinha-button-fluxo">
        <div class="button-fluxo">
          <g-button
            tipo="amarelo" 
            negritoTexto 
            altura="35px"
            largura="100%"
            v-on:acao="salvaDados"
          >
            SALVAR
          </g-button>
        </div>
      </div>
    </g-card>
    <PToast group="gama" position="bottom-center"/>

    <PDialog
      :closable="false" 
      v-model:visible="popupTrocarSenha"
      :breakpoints="{'1200px': '50%', '800px': '70%', '400px': '90%'}"
      :style="{ width: '40%' }"
    >

    <template #header >
      <div class="titulo-popup">ALTERAR SENHA</div>
              
    </template>


      <div class="container-popup">
  
        <div class="conteudo-popup">
          <g-form>
            <div class="input-senha-atual">
              <div class="titulo-conteudo-filtros">Senha atual</div>
              <div class="flexSenhaInput">
                <PInputText :class="{'p-invalid':v$.senhaAtual.$invalid && submit}"  v-model="v$.senhaAtual.$model"  :type="tipoA"></PInputText>
                <i v-on:click="mostrarSenhaA" class="pi pi-eye olho "></i>
              </div>
            </div>
            <div class="input-senha-nova">
              <div class="titulo-conteudo-filtros">Nova Senha</div>
              <div class="flexSenhaInput">
                <PInputText :class="{'p-invalid':v$.senhaNova.$invalid && submit}" v-model="v$.senhaNova.$model" :type="tipoB"></PInputText>
                <i v-on:click="mostrarSenhaB" class="pi pi-eye olho "></i>
              </div>
            </div>
            <div class="input-senha-nova-confirmacao">
              <div class="titulo-conteudo-filtros">Confirmação da nova senha</div>
              <div class="flexSenhaInput">
                <PInputText v-model="senhaNovaConfirmacao" :type="tipoC"></PInputText>
                <i v-on:click="mostrarSenhaC" class="pi pi-eye olho "></i>
              </div>
            </div>
          </g-form>

        
        </div>


          <div class="botoes-popup">
            <div>
              <g-button
              tipo="cinza"
              negritoTexto 
              largura="200px" 
              altura="35px"
              v-on:acao="fecharpopup"
              >
              CANCELAR
              </g-button>
            </div>
            <div>
              <g-button
              tipo="amarelo"
              negritoTexto
              largura="200px" 
              altura="35px" 
              v-on:acao="alterarSenha"
              >
              ALTERAR
              </g-button>
            </div>
          </div>

      </div>
      
    </PDialog>
    
  </div>
</template>

<script>
import MeuPerfil from './MeuPerfil.js' 
export default MeuPerfil
</script>

<style scoped>
.flexSenhaInput {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.olho {  
    color: #6c757d;
    margin-left: 6px;
}
.texto-alterar-senha{
  margin-top: 30px;
  margin-bottom: 10px;
  color: #4d2b18;
  text-decoration: underline;
  cursor: pointer;
}
.botoes-popup{
  margin-top: 30px;
}
.borda{
  border: none;
}
.input-nome{
  display: flex;
  border: 1px solid #e1e5e8;
  border-radius: 3px;
}
.alinha-button-fluxo{
  margin: 0;
}
.containerbotoes{
  display: flex;
  margin-top: 20px;
  gap: 10px;
  justify-content: center;
  align-items: center;
}

.meusdados{
  font-family: 'MontSerrat';
  color:#717171;
  display: flex;
  justify-content: center;
  font-size: 18px;
  margin-bottom: 10px;

}
.desabilitar{
  position: relative;
}



.container-titulo{
  display: flex;
  justify-content: left;
}

.texto-titulo{
  color: #4d2b18;
  font-size: 20px;
  font-weight: bold;
  margin-left: 15px;
}


.p-input-icon-right{
  display: block;
}

.p-input-icon-right i{
  color: black !important;
  opacity: 1 !important;
}

span.p-input-icon-right{
  cursor: pointer;
}

.input-label{
  text-align: left;
  font-family: 'MontSerrat';
  font-size: 13px;
  color:#717171;
  font-weight: bold;
}

.input-labelpopup{
  font-family: 'MontSerrat';
  font-size: 13px;
  color:#717171;
  font-weight: bold;
  margin-top: 10px;
}


.container-alterar-senha{
  display: flex;
  justify-content: center;
}

.botao-salvar{
  margin: 0 auto;
  margin-bottom: 30px;
}

.container-popup{
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

}

.cabecalho-popup{
  height: 60px;
  background-color: #f5ad15;
}

.titulo-popup{
  font-size: 20px;
  color: #4d2b18;
  font-weight: bold;
}

.lapis{
  margin-top: 13px;
  margin-right: 11px;
}


.active{
  opacity: 1;
  font-weight: bold;
}
.input-meu-perfil .p-inputtext, .input-meu-perfil .p-input-icon-right .p-inputtext{
  width: 100%;

}




@media (min-width:310px) {

  .container-dados{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(5, 1fr);
    grid-column-gap: 3%;
    grid-row-gap: 10px;
    width: 100%;
  }
  .email { grid-area: 1 / 1 / 2 / 2; }
  .login { grid-area: 2 / 1 / 3 / 2; }
  .nome { grid-area: 3 / 1 / 4 / 2; }
  .telefone { grid-area: 4 / 1 / 5 / 2; }
  .data-validade { grid-area: 5 / 1 / 6 / 2; }
}

@media (min-width:368px) {

}

@media (min-width:600px) {
  .container-dados{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 3%;
    grid-row-gap: 10px;
    width: 100%;
  }
  .email { grid-area: 1 / 1 / 2 / 3; }
  .login { grid-area: 2 / 1 / 3 / 2; }
  .nome { grid-area: 2 / 2 / 3 / 3; }
  .telefone { grid-area: 3 / 2 / 4 / 3; }
  .data-validade { grid-area: 3 / 1 / 4 / 2; }

}

@media (min-width:801px) {
  
  .olho {
          left: 23rem;
        }

}

@media (min-width:1025px) { 

  .container-dados{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 3%;
    grid-row-gap: 10px;
    width: 100%;
  }

.email { grid-area: 1 / 1 / 2 / 2; }
.login { grid-area: 1 / 2 / 2 / 3; }
.nome { grid-area: 1 / 3 / 2 / 4; }
.telefone { grid-area: 2 / 1 / 3 / 2; }
.data-validade { grid-area: 2 / 2 / 3 / 3; }


  

    .meusdados {
    font-family: 'MontSerrat';
    color:#717171;
    display: flex;
    justify-content: left;
    font-size: 20px;
    margin-left: 12px;
  }
}

@media (min-width:1281px) {
}


</style>
